// TemplateOffer.js
import React from "react";
import { Card } from "primereact/card";
import { SimpleButton } from "../../styles";
import styles from "./TemplateOffer.module.css";

import { InfoGridOffer } from "../../common";

function TemplateOffer({
  imgHead,
  title,
  subtitle,
  text,
  price,
  onMehrClick,
  onBuchenClick,
  duration,
  maxGuests,
  overalleLevel,
}) {
  const header = (
    <div onClick={onMehrClick} style={{ cursor: "pointer" }}>
      <img alt="Card" src={imgHead} />
    </div>
  );

  const footer = (
    <div
      className={`${styles.flex} ${styles["flex-wrap"]} ${styles["justify-content-end"]} ${styles["gap-2"]}`}
    >
      <SimpleButton label="Details" onClick={onMehrClick} variant="primary" />
      <SimpleButton label="Buchen" onClick={onBuchenClick} variant="primary" />
    </div>
  );

  return (
    <div
      className={`${styles.card} ${styles.flex} ${styles["justify-content-center"]}`}
    >
      <Card
        title={
          <>
            <InfoGridOffer
              duration={duration}
              maxGuests={maxGuests}
              overalleLevel={overalleLevel}
            />
            <span className={styles.cardTitle}>{title}</span>
          </>
        }
        subTitle={<span className={styles.cardSubTitle}>{subtitle}</span>}
        footer={<div className={styles.cardFooter}>{footer}</div>}
        header={<div className={styles.cardHeader}>{header}</div>}
        className={styles.card}
        style={{ backgroundColor: "transparent" }}
      >
        <p className={styles.cardText}>{text}</p>

        <div className={styles["price-section"]}>
          <span className={styles["price-amount"]}>{price}</span>
        </div>
      </Card>
    </div>
  );
}

export default TemplateOffer;
